import { memo, useCallback, useState } from 'react';

import { PageTitle } from '@dec/shared';
import GridApplication from 'app/components/grid/gridApplication';
import * as Icon from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { type DisbursementSummary } from '../../models/Disbursement';
import { type PaymentFilter } from '../../models/Payment';
import { disbursementService } from '../../services/disbursement.service';

import { getPaymentColumns } from './columns';
import { DisbursementFilters } from './filters';
import { mapPaymentFormToSearch, type PaymentFilterForm } from './search';

export const ViewDisbursementsPage = memo(() => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [search, setSearch] = useState<PaymentFilter>({});

  /*
   * Navegación al detalle.
   *
   * La navegación queda en la página porque useNavigate
   * es un hook. columns.ts solamente recibe el callback.
   */
  const handleViewPayment = useCallback(
    (row: DisbursementSummary) => {
      navigate('/disbursement/view/' + row.id);
    },
    [navigate]
  );

  /*
   * Columnas del grid.
   */
  const columns = getPaymentColumns(handleViewPayment);

  /*
   * Nueva búsqueda.
   */
  const handleSearch = useCallback((values: PaymentFilterForm) => {
    console.log({ values: values });
    setSearch(mapPaymentFormToSearch(values));
  }, []);

  /*
   * Limpiar búsqueda.
   *
   * filter.tsx se encarga de limpiar visualmente
   * el formulario.
   *
   * La página limpia el objeto enviado al grid.
   */
  const handleClear = useCallback(() => {
    setSearch({});
  }, []);

  return (
    <>
      <PageTitle title={t('disbursement.viewDisbursements')} icon={Icon.Transparency} />

      <DisbursementFilters onSearch={handleSearch} onClear={handleClear} />

      <GridApplication url={disbursementService.baseUrl} columnDefs={columns} search={search} />
    </>
  );
});

ViewDisbursementsPage.displayName = 'ViewDisbursements';
